var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplaints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.56962V7.00019M7.5 9.43076H7.50622M6.43616 1.44633L1.16674 10.0384C1.0581 10.2222 1.00061 10.4305 1 10.6427C0.999397 10.8549 1.05569 11.0636 1.16327 11.2479C1.27086 11.4323 1.426 11.5859 1.61325 11.6935C1.8005 11.8011 2.01333 11.859 2.23058 11.8613H12.7694C12.9867 11.859 13.1995 11.8011 13.3868 11.6935C13.574 11.5859 13.7291 11.4323 13.8367 11.2479C13.9443 11.0636 14.0006 10.8549 14 10.6427C13.9994 10.4305 13.9419 10.2222 13.8333 10.0384L8.56384 1.44633C8.45293 1.26775 8.29677 1.1201 8.11043 1.01763C7.92409 0.91516 7.71385 0.861328 7.5 0.861328C7.28615 0.861328 7.07592 0.91516 6.88957 1.01763C6.70323 1.1201 6.54707 1.26775 6.43616 1.44633Z",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaints);
export default __webpack_public_path__ + "static/media/complaints.315c4503b964eab99f67959f91d53656.svg";
export { ForwardRef as ReactComponent };